import React from 'react';
import PropTypes from 'prop-types';
import { toLower } from '../../../../util/lodashlike';
import styled from 'styled-components';
import { getAlertColorCode } from '../../utils';

const RatingHighlighter = ({ color }) => `
  background: ${color};
  border-radius: 15px;
  padding: 2px 15px;
  display: inline-block;
`;

const RatingBold = ({ color }) => `
  color: ${color};
`;

const RatingHighlighterWrapper = styled.div`
  ${RatingHighlighter}
`;

const RatingWrapper = styled.b`
  ${RatingBold}
`;
const getItemValue = (value) => (value ? value : '-');

const RiskRating = ({ value, highlighter = false }) => {
  const val = toLower(value);
  const color = getAlertColorCode(val);

  return (
    <>
      {highlighter ? (
        <RatingHighlighterWrapper color={color}>
          {getItemValue(value)}
        </RatingHighlighterWrapper>
      ) : (
        <RatingWrapper color={color}>{getItemValue(value)}</RatingWrapper>
      )}
    </>
  );
};

RiskRating.propTypes = {
  value: PropTypes.string,
  highlighter: PropTypes.bool
};

export default RiskRating;
